import { render, staticRenderFns } from "./MasterSetting.vue?vue&type=template&id=2ffbd4f8"
import script from "./MasterSetting.vue?vue&type=script&lang=js"
export * from "./MasterSetting.vue?vue&type=script&lang=js"
import style0 from "./MasterSetting.vue?vue&type=style&index=0&id=2ffbd4f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports